import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type DeveloperRouteProps = {
  children: ReactNode;
};

/**
 * Gate for the integrations-beta UI while its frontend is unfinished: only
 * PlatformUsers flagged `is_developer` may reach it. This is a visibility gate
 * only - the integration-platform API still enforces its own permissions.
 */
const DeveloperRoute = ({ children }: DeveloperRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pp = user?.platform_profile;

  if (user && !user.is_pass_reset && !(pp && !pp.is_pass_reset)) {
    return <Navigate to="/reset-password" replace />;
  }

  if (!user || !pp?.is_developer || pp?.is_archived) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default DeveloperRoute;
